module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIzZjBkNGY0ZTNjOGY3YmZiNmU3MGFmNWVmNzgzNDc2NS5zdmciOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/icons/iconfont.svg
 ** module id = 206
 ** module chunks = 0
 **/